var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightS(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.95573 5.99745L4.13907 9.09416C4.04327 9.19949 3.99696 9.32413 4.00015 9.46808C4.00335 9.61203 4.05285 9.73667 4.14865 9.842C4.24446 9.94733 4.35783 10 4.48876 10C4.61969 10 4.73306 9.94733 4.82886 9.842L7.77007 6.59783C7.84671 6.51357 7.90419 6.41877 7.94252 6.31344C7.98084 6.20811 8 6.10278 8 5.99745C8 5.89212 7.98084 5.78679 7.94252 5.68146C7.90419 5.57613 7.84671 5.48133 7.77007 5.39707L4.81928 2.1529C4.72348 2.04757 4.61171 1.99666 4.48397 2.00017C4.35623 2.00368 4.24446 2.0581 4.14865 2.16343C4.05285 2.26876 4.00494 2.3934 4.00494 2.53735C4.00494 2.68131 4.05285 2.80595 4.14865 2.91128L6.95573 5.99745Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightS);
export default __webpack_public_path__ + "static/media/arrow-right-s.1eb4ac12a712ef403597be7a52dd7e18.svg";
export { ForwardRef as ReactComponent };